import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Apptext} from 'shared/classes/apptext';
import {ApptextsRepository} from '../repositories/apptexts.repository';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import { Company } from 'shared/classes/company';

@Injectable()
export class ApptextsService {

  constructor(private apptextsRepository: ApptextsRepository) { }

  public getTexts(): Observable<Array<Apptext>> {
    return this.apptextsRepository.getTexts();
  }

  public setText(text: Apptext): Observable<Apptext> {
    return this.apptextsRepository.setText(text);
  }

  public addText(text: Apptext): Observable<Apptext> {
    return this.apptextsRepository.addText(text);
  }

  public deleteText(text: Apptext): Observable<boolean> {
    return this.apptextsRepository.deleteText(text);
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.apptextsRepository.getAllTargetGroups();
  }

  public getAllCompanies(): Observable<Array<Company>> {
    return this.apptextsRepository.getAllCompanies();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/apptexts/services/apptexts.service.ts